import React, { useEffect, useState } from "react";
import { getUserInfo } from "../../services/profile.service";
import { getPaymentStatus, submitTransactionAdd, SubscriptionTransactionDto } from "../../services/subscription.service";
import { useNavigate } from "react-router-dom";


const RazorpayCheckout = ({ amount, subscriptionId}) => {

  const navigate = useNavigate(); 

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const userInfoDetails = await getUserInfo();
        if (userInfoDetails && userInfoDetails.length > 0) {
          const userInfo = userInfoDetails[0]; // Access the first object
          setName(userInfo.name);
          setEmail(userInfo.email);
          setContact(userInfo.phone);
        }
      } catch (error) {
        console.error("Error fetching user info for Razorpay:", error);
      }
    };

    fetchUserInfo();
  }, []);

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const openRazorpay = async () => {
    const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
  
    if (!res) {
      alert("Razorpay SDK failed to load. Please check your internet connection.");
      return;
    }
  
    let isFailureHandled = false; // Flag to prevent duplicate failure handling
  
    const options = {
      key: "rzp_live_Z0sEQDntzVbYrZ", // Replace with your Razorpay Key ID
      amount: amount * 100, // Convert to paisa
      currency: "INR",
      name: "SMART",
      description: "Subscription Payment",
      handler: async function (response) {
        console.log("Payment Successful:", response);
        const checkStatusFromRazorPay = await getPaymentStatus(response.razorpay_payment_id);
        console.log("payment status"+checkStatusFromRazorPay)
        alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
  
    

       //IF PAYMENT STATUS IS 
       if(checkStatusFromRazorPay && checkStatusFromRazorPay==='captured'){
          const transactionDto = new SubscriptionTransactionDto(
            subscriptionId,
            amount,
            "RAZORPAY",
            "S", // Success
            response.razorpay_payment_id
          );
          const verifyRes = await submitTransactionAdd(transactionDto);
          if (verifyRes && verifyRes.success) {
            navigate("/dashboard", {
              state: {
                activeTab: "v-pills-subscription",
                successMessage: verifyRes.message,
              },
            });
          } else {
            alert("Payment Verification Failed!");
            navigate("/dashboard", {
              state: {
                activeTab: "v-pills-subscription",
                errorMessage: "Payment Verification Failed",
              },
            });
          }
       
      }


      },
      prefill: {
        name: name,
        email: email,
        contact: contact,
      },
      theme: {
        color: "#3399cc",
      },
    };
  
    const rzp = new window.Razorpay(options);
  
    // Handle payment failure
    rzp.on("payment.failed", async function (response) {

      if (isFailureHandled) return; // Prevent duplicate execution
      isFailureHandled = true;

      console.log("Payment Failed", response);
      alert("Payment Failed: " + response.error.description);

      const transactionDto = new SubscriptionTransactionDto(
        subscriptionId,
        amount,
        "RAZORPAY",
        "F", // Failure
        response.error.metadata?.payment_id || "UNKNOWN"
      );

      const verifyRes = await submitTransactionAdd(transactionDto);
      if(verifyRes){
        navigate("/dashboard", {
          state: {
            activeTab: "v-pills-subscription",
            errorMessage: "Payment Failed: " + response.error.description,
          },
        });

      }
  
    
    });
  
    rzp.open(); 
  };
  


  return (
    <button className="subscription-btn" onClick={openRazorpay}>
      Subscribe
    </button>
  );
};

export default RazorpayCheckout;
